
import './App.css';
import { MainRoute } from './Pages/MainRoute';
import { FooterContainer } from './Footer/containers/footer';
import  Navbar  from './Components/Navbar';


function App() {
  return (
    <div className="App">

       <Navbar/>
      <MainRoute/>
      <FooterContainer/>

    </div>
  );
}

export default App;
